import {Injectable, Pipe, PipeTransform} from '@angular/core';
export class BytesTransformPipe implements PipeTransform {
/**
 * @param {?} value
 * @param {?=} args
 * @return {?}
 */
transform(value, args?): Array<any> {
        if (value && value.changingThisBreaksApplicationSecurity !== undefined) {
            value = value.changingThisBreaksApplicationSecurity;
        }
        if(value === 0) {
          value = 0 + '/B';
        }else{
          if (value / 1000 < 1) value = value.toFixed(2) + '/B';
          if (value / 1000000 < 1) value = (value / 1000).toFixed(2) + '/KB';
          if (value / 1000000000 < 1) value = (value / 1000000).toFixed(2) + '/MB';
          else value =  (value / 1000000000).toFixed(2) + '/GB';
        }

        return value;
    }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
    name: 'BytesTransform'
}, ] },
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BytesTransformPipe_tsickle_Closure_declarations() {
/** @type {?} */
BytesTransformPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BytesTransformPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
